// @ts-nocheck
import PensionsInfoScrape from './PensionsInfoScrape';

export default PensionsInfoScrape;
